import { render, staticRenderFns } from "./HostedSignalingServer.vue?vue&type=template&id=9b5227f8&scoped=true"
import script from "./HostedSignalingServer.vue?vue&type=script&lang=js"
export * from "./HostedSignalingServer.vue?vue&type=script&lang=js"
import style0 from "./HostedSignalingServer.vue?vue&type=style&index=0&id=9b5227f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5227f8",
  null
  
)

export default component.exports